<template>
  <div class="leader-board-container">
    <ins :class="[{ 'half-top-margin': halfTopMargin }, { 'no-top-margin' : noTopMargin}, 'adsbygoogle medium-rectangle']" data-ad-client="ca-pub-2580109990739065" data-ad-slot="4200499317"></ins>
  </div>
</template>
<script>
  export default {
    props: {
      wait: {
        type: Boolean,
        default: false
      },
      waitLonger: {
        type: Boolean,
        default: false
      },
      noTopMargin: {
        type: Boolean,
        default: false
      },
      halfTopMargin: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      record: {}
    }),
    mounted () {
      // fetch ad from api
      // if no result, display google
      if (this.waitLonger) {
        setTimeout((window.adsbygoogle = window.adsbygoogle || []).push({}), 1000)
      } else if (this.wait) {
        setTimeout((window.adsbygoogle = window.adsbygoogle || []).push({}), 800)
      } else {
        setTimeout((window.adsbygoogle = window.adsbygoogle || []).push({}), 500)
      }
    }
  }
</script>

<style scoped>
  .medium-rectangle {
    width: 300px!important;
    max-width: 100%;
    height: 300px!important;
    display: block;
    margin: 40px auto 0 auto;
    overflow: hidden;
  }

  .no-top-margin {
    margin-top: 0!important;
  }

  .half-top-margin {
    margin-top: 20px!important;
  }

  .leader-board-container {
    max-width: 728px!important;
    margin-right: auto;
    margin-left: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/LeaderBoardMedium.vue